import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';

// Updates an existing nis_masterlist row via PUT /nisMasterlist/update/:id
const useUpdateNisMasterlist = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const updateNisMasterlist = async (id, formData) => {
    setLoading(true);
    setSuccess(false);
    setError('');

    try {
      const response = await axiosApi.put(`/nisMasterlist/update/${id}`, formData);
      if (response.status === 200 || response.status === 204) {
        setSuccess(true);
        return { success: true, message: response.data?.message || 'NIS data successfully updated!' };
      }
      const message = response.data?.message || 'Failed to update the data. Please try again.';
      setError(message);
      return { success: false, message };
    } catch (err) {
      console.error('Error updating nis masterlist:', err);
      const message =
        err.response?.data?.message ||
        err.response?.data?.details ||
        'Something went wrong. Please try again later.';
      setError(message);
      return { success: false, message };
    } finally {
      setLoading(false);
    }
  };

  return { loading, success, error, updateNisMasterlist };
};

export default useUpdateNisMasterlist;
